import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";

import { addM } from "./utils.js";

// ── Firebase configs ──────────────────────────────────────────
export const FB_PROD = {
  apiKey: "AIzaSyDjDtyb09Vga1f_jaMDX0H1VuHwXcV82gs",
  authDomain: "contas-lar.firebaseapp.com",
  projectId: "contas-lar",
  storageBucket: "contas-lar.firebasestorage.app",
  messagingSenderId: "551024136872",
  appId: "1:551024136872:web:b3f9ab8cc879b682d3e89d",
};
export const FB_TEST = {
  apiKey: "AIzaSyAKMeShYL-MjwWrxKe-y8nMb8B0ykrimvM",
  authDomain: "contas-lar56.firebaseapp.com",
  projectId: "contas-lar56",
  storageBucket: "contas-lar56.firebasestorage.app",
  messagingSenderId: "306803758002",
  appId: "1:306803758002:web:fa2cbf8546ce7c1049caab",
};
export const FB_ADMIN = {
  apiKey: "AIzaSyDmV3l2FYQefYP4PEIQPSGD5xYccB9-K18",
  authDomain: "appfinancaadmin.firebaseapp.com",
  projectId: "appfinancaadmin",
  storageBucket: "appfinancaadmin.firebasestorage.app",
  messagingSenderId: "869841527602",
  appId: "1:869841527602:web:18d65941ae0d50dbe36d2b",
};

export const ADMIN_CPF = import.meta.env.VITE_ADMIN_CPF || "12345678910";
export const ADMIN_PW = import.meta.env.VITE_ADMIN_PW || "admin@lar2025";

const _dbs = {};

export function getDb(cfg) {
  const k = cfg.projectId;
  if (_dbs[k]) return _dbs[k];
  const ex = firebase.apps?.find((a) => a.name === k);
  const app = ex || firebase.initializeApp(cfg, k);
  _dbs[k] = app.firestore();
  return _dbs[k];
}

export const dbA = () => getDb(FB_ADMIN);

function getFirebaseApp(cfg) {
  const k = cfg.projectId;
  const ex = firebase.apps?.find((a) => a.name === k);
  return ex || firebase.initializeApp(cfg, k);
}

export async function signInWithGoogle(cfg) {
  const provider = new firebase.auth.GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  const auth = getFirebaseApp(cfg).auth();
  const result = await auth.signInWithPopup(provider);
  return result.user.email;
}

export const fsAll = (db, col) =>
  db
    .collection(col)
    .get()
    .then((s) => s.docs.map((d) => ({ ...d.data(), id: d.id })));

export const fsSave = (db, col, id, dat) => db.collection(col).doc(id).set(dat);

export const fsDel = (db, col, id) => db.collection(col).doc(id).delete();

export const fsOne = (db, col, id) =>
  db
    .collection(col)
    .doc(id)
    .get()
    .then((d) => (d.exists ? { ...d.data(), id: d.id } : null));

export const fsByMonth = (db, ym) => {
  const nxt = addM(ym, 1);
  return db
    .collection("lancamentos")
    .where("date", ">=", `${ym}-01`)
    .where("date", "<", `${nxt}-01`)
    .get()
    .then((s) => s.docs.map((d) => ({ ...d.data(), id: d.id })));
};
